const items = [
  {
    icon: 'contacts',
    title: 'core.dashboard.contact.title',
    description: 'core.dashboard.contact.description',
    to: 'db.database.index',
    button_title: 'core.dashboard.contact.button'
  },
  {
    icon: 'mailings',
    title: 'core.dashboard.mailing.title',
    description: 'core.dashboard.mailing.description',
    to: 'mailer.mailing.create',
    button_title: 'core.dashboard.mailing.button'
  },
  {
    icon: 'phone-line',
    title: 'core.dashboard.phone-line.title',
    description: 'core.dashboard.phone-line.description',
    to: 'pbx.worksheet.index',
    button_title: 'core.dashboard.phone-line.button',
    is_additional: true
  },
  {
    icon: 'client-info',
    title: 'core.dashboard.client-info.title',
    description: 'core.dashboard.client-info.description',
    to: 'autoinformer.campaign.index',
    button_title: 'core.dashboard.client-info.button',
    is_additional: true
  },
  {
    icon: 'buy-numbers',
    title: 'core.dashboard.buy-numbers.title',
    description: 'core.dashboard.buy-numbers.description',
    to: 'phone-number.number.buy',
    button_title: 'core.dashboard.buy-numbers.button',
    is_additional: true
  },
  {
    icon: 'data-base',
    title: 'core.dashboard.data-base.title',
    title2: 'core.dashboard.data-base.title2',
    description: 'core.dashboard.data-base.description',
    to: 'autocaller_v2.campaign.index',
    is_action: true,
    button_title: 'core.dashboard.data-base.button',
    button_title2: 'core.dashboard.data-base.button2'
  }
];

export default items;
